import { DOC_HOST } from '../../../base/constants/cgi-base';
// 用户会员信息
export var VIP_INFO_CGI = "".concat(DOC_HOST, "/api/vipcenter/info/all");
export var TIPS_SHOW_CGI = "".concat(DOC_HOST, "/api/personalize/show/tips");
